import {gql} from '@apollo/client';

export const CREATE_ADMIN = gql`
  mutation createAdmin($input: AdminInput!) {
    createAdmin(input: $input) {
      uid
      fullName
      email
      phoneNumber
    }
  }
`;

export const DELETE_ADMIN = gql`
  mutation deleteAdmin($id: ID!) {
    deleteAdmin(id: $id) {
      uid
      fullName
    }
  }
`;
